// licenseHooks.js - Custom hooks for license
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reset, loadLicense, uploadLicense } from ".";

/**
 * Hook for license functionality
 */
export const useLicense = () => {
  const dispatch = useDispatch();
  const license = useSelector((state) => state.license);

  // Load license
  const handleLoadLicense = useCallback(() => {
    return dispatch(loadLicense());
  }, [dispatch]);

  // Reset license
  const handleReset = useCallback(() => {
    return dispatch(reset());
  }, [dispatch]);

  // Upload license
  const handleUploadLicense = useCallback(
    (licenseJson) => {
      return dispatch(uploadLicense(licenseJson));
    },
    [dispatch]
  );

  return {
    // State
    isLoading: license.loading,
    isLoaded: license.loaded,
    isSaving: license.saving,
    isSaved: license.saved,
    status: license.status,

    // Actions
    loadLicense: handleLoadLicense,
    reset: handleReset,
    uploadLicense: handleUploadLicense,
  };
};
